export default "__VITE_ASSET__EBJo03t2__"